export const baseUrl = "https://lms.neurotherapycourse.org/api"